import { useCallback } from 'react'

import { getIsNativeToken, isSellOrder } from '@cowprotocol/common-utils'
import { Currency } from '@cowprotocol/currency'

import { Field } from 'legacy/state/types'

import { useNavigateOnCurrencySelection, useOnCurrencySelection as useTradeOnCurrencySelection } from 'modules/trade'

import { useSwapDerivedState } from './useSwapDerivedState'
import { useUpdateSwapRawState } from './useUpdateSwapRawState'

import { SELL_ETH_RESET_STATE } from '../consts'

export function useOnCurrencySelection(enableSellEqBuy = false): (field: Field, currency: Currency | null) => void {
  const { orderKind } = useSwapDerivedState()
  const tradeOnCurrencySelection = useTradeOnCurrencySelection(enableSellEqBuy)
  const updateSwapState = useUpdateSwapRawState()
  const navigateOnCurrencySelection = useNavigateOnCurrencySelection(enableSellEqBuy)

  return useCallback(
    (field: Field, currency: Currency | null) => {
      // Same logic as in getEthFlowOverridesOnSwitch()
      if (!isSellOrder(orderKind) && currency && getIsNativeToken(currency)) {
        navigateOnCurrencySelection(field, currency, () => {
          updateSwapState(SELL_ETH_RESET_STATE)
        })
        return
      }

      return tradeOnCurrencySelection(field, currency)
    },
    [tradeOnCurrencySelection, navigateOnCurrencySelection, orderKind, updateSwapState],
  )
}
